module.exports = __webpack_public_path__ + "img/31.b36e0e15.jpg";